import { render, staticRenderFns } from "./JCRecord.vue?vue&type=template&id=84a79030&"
import script from "./JCRecord.vue?vue&type=script&lang=js&"
export * from "./JCRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports